import { queryClient } from "@/v1/utils/queryClient";
import { QueryKeys } from "@/v2/utils/queryKeys.constants";

// What the skin's Games tab reads, which a retrieval may have changed.
const FREE_SPINS_VALUES_QUERIES = [
  QueryKeys.SKIN_GAMES,
  QueryKeys.SKIN_GAME_CONFIGURATIONS,
  QueryKeys.SKIN_CONFIGURATION_CURRENCIES,
  QueryKeys.FREE_SPINS_V2,
];

/** Reloads the cached free spins values after a retrieval. */
export const invalidateFreeSpinsValues = () => {
  FREE_SPINS_VALUES_QUERIES.forEach((key) => {
    void queryClient.invalidateQueries([key]);
  });
};
